import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import './rsbutton.css';

const RsLink = ({ to, onClick, className, children, iconClass, disabled }) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick(e);
  };

  return (
    <Link
      to={disabled ? '#' : to}
      className={`btn ${className} ${disabled ? 'disabled-link' : ''}`}
      onClick={handleClick}
    >
      <i className={`font-size-16 align-middle btn-i ${iconClass}`}></i> {children}
    </Link>
  );
};

RsLink.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.string,
  iconClass: PropTypes.string,
  disabled: PropTypes.bool
};

RsLink.defaultProps = {
  to: '#',
  className: 'btn-cancle',
  iconClass: 'bx bx-window-close',
  onClick: () => {},
  disabled: false
};

export default RsLink;
